import React, { useState } from "react";

const PropertyFaqList = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);
  const getImagePath = (label, extension) => {
    try {
      return require(`../../images/icons/${label.toLowerCase()}.${extension}`);
    } catch (error) {
      return "/images/icons/default.svg";
    }
  };
  return (
    <div className="container">
      <div className="question  mt-3" onClick={() => setIsOpen(!isOpen)}>
        <span className="questionText">{question}</span>
        <span className="icon">
          {isOpen ? (
            <img src={getImagePath("arrowup", "svg")} alt="logo" />
          ) : (
            <img src={getImagePath("arrowdown", "svg")} alt="logo" />
          )}
        </span>
      </div>
      {isOpen && <div className="answer mt-3 mb-3">{answer}</div>}
    </div>
  );
};
export default PropertyFaqList;
